<script>
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";
import i18n from "@/i18n";

export default {
  name: "MemberSearchItem",
  props: {
    itemData: {
      type: Object
    }
  },
  components: {
    BaseAvatar
  },
  computed: {
    isVerified() {
      const politicianProfile = this.itemData.profiles.filter((profile)=>{return profile.type === 'POLITICIAN'})[0]
      const memberProfile = this.itemData.profiles.filter((profile)=>{return profile.type === 'MEMBER'})[0]

      return !politicianProfile && memberProfile;
    },
    verifiedIconTooltipText() {
      return this.isVerified ? i18n.global.t('takeOver.verifiedProfile') : "";
    }
  }
}
</script>

<template>
<div class="member-list-item">
  <base-avatar class="member-list-item__avatar"
               :img-hash="itemData.user.largeImgHash"
               :size="'75'"
  />
  <div class="d-flex">
    <router-link :to="{name: 'UserView', params: {id: itemData.user.id}}"
                 target="_blank"
                 class="member-list-item__name"
    >{{ itemData.user.name }}</router-link>
    <div class="user-verified-control"
         :class="{'user-verified-control--verified': isVerified}"
         v-tooltip.top="verifiedIconTooltipText"
    ><font-awesome-icon :icon="['fas', 'check']" /></div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.member-list-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, .15);

  &__avatar {
    margin-right: 12px;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
  }

  .user-verified-control {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    width: 16px;
    margin-left: 10px;
    background: #bbbbbb;
    border-radius: 24px;
    color: #fff;
    font-size: 10px;
    &--verified {
      background: #7835a6;
      cursor: default;
    }
  }
}
</style>